import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  @Input() message: string;
  @Input() title: string;
  modalReference: NgbModalRef;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'sm'
  };

  constructor(private modalService: NgbModal) { }

  async open() {
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
    return await this.modalReference.result.then();
  }
}
